module.exports = __webpack_public_path__ + "static/media/strip-2.f376dc29.svg";